export default __webpack_public_path__ + "static/media/pvilla1-1.c31a16cf.webp";